export const { MonetizationKey } = await import('./keys/MonetizationKey')
export const { AppConfigKey } = await import('./keys/AppConfigKey')
export const { DefLinksConditionsKey } = await import('./keys/DefLinksConditionsKey')
export const { DefLinksConfigKey } = await import('./keys/DefLinksConfigKey')
export const { ScreenStyleConfigKey } = await import('./keys/ScreenStyleConfigKey')
